import React from 'react';

import UserIcon from 'components/user_icon';

interface Props {
  assignee?: { name: string };
}

export default function Assignee({ assignee }: Props) {
  return (
    <div className="d-flex align-items-center gap-1">
      <div>{assignee?.name || 'Unassigned'}</div>
      <UserIcon
        size="sm"
        user={assignee || { imageUrl: '/images/default-profile-photo.png', name: 'Unassigned' }}
      />
    </div>
  );
}
